'use strict'; /* eslint-disable no-console, no-unused-vars */

import actions from './actions.js';

import { TOGGLE_ESTIMATOR } from './mutations';


const state = {
  estimatorIsOpen: false,
  locale: 'US',
}

const mutations = {

  setLocale(state, payload){
    // expects "true" if domain_uk is a class on the body
    state.locale = payload ? 'UK' : 'US';
  },

  [TOGGLE_ESTIMATOR](state, {payload}) {
    // console.log('clickkyy');
    state.estimatorIsOpen = !state.estimatorIsOpen;
  },
}

const EstimatorStore = {
  state,
  mutations,
  actions,
}

export default EstimatorStore;


// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/estimator/store.js